export default __webpack_public_path__ + "446a3d72d817e72400e0225bc3ee573e.png";